module.exports = __webpack_public_path__ + "static/media/delete.bb7669c0.svg";